let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f6Avr")).then(() => parcelRequire('1ouZ7'));